import React from 'react'
import { Tooltip } from '@entur/tooltip'

type OptionalTooltipWrapperProps = {
  placement: 'top' | 'left' | 'right' | 'bottom-left' | 'bottom' | 'bottom-right'
  tooltipText: string
  children: React.ReactElement
  enabled: boolean
}
export const OptionalTooltipWrapper: React.FC<OptionalTooltipWrapperProps> = ({
  enabled,
  tooltipText,
  children,
  placement,
}) => {
  const tooltipTextElement = <span style={{ lineHeight: '1.5em' }}>{tooltipText}</span>
  return enabled ? (
    <Tooltip placement={placement} content={tooltipTextElement}>
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  )
}
